// extracted by mini-css-extract-plugin
export default {"size":"support_size__wA5Oq"};